import { IApiUserAccount } from '../tap-api/user-service.types';

/* Версия плана */
export enum PlanVersionStatus {
    Created = 'created',
    Published = 'published',
    Unpublished = 'unpublished',
    Changed = 'changed',
    Deleted = 'deleted',
}

export type IApiPlanVersion = {
    id: number,
    planId: number,
    status: PlanVersionStatus,
    description: string,
    createdAt: number,
    createdAtUtc: string,
    jobs: [
        string,
        {
            id: string,
            status: string,
        },
    ],
    deletedAtUtc?: string,
    publishedAtUtc?: string,
    unpublishedAtUtc?: string,
    changedAtUtc?: string,
    publishedDescription?: string,
    unpublishedDescription?: string,
    publishedBy: IApiUserAccount,
    unpublishedBy: IApiUserAccount,
    createdBy: IApiUserAccount,
    changedBy: IApiUserAccount,
    deletedBy: IApiUserAccount,
    baseVersionId: number,
    lastScheduleJob?: {
        id: number,
        type: string,
        status: string,
        startedAtUtc: string,
        startedBy?: IApiUserAccount,
        finishedAtUtc?: string,
        hasFullResult: boolean,
        params: {
            versionType: string,
        },
    },
}

// Получаем статус версии плана
export const getPlanVersionStatus = (status: PlanVersionStatus): string => {
    switch (status) {
        case PlanVersionStatus.Changed:
            return 'Изменена';
        case PlanVersionStatus.Created:
            return 'Создана';
        case PlanVersionStatus.Deleted:
            return 'Удалена';
        case PlanVersionStatus.Published:
            return 'Опубликована';
        default:
            return 'Снята с публикации';
    }
}

export type VersionEntity = {
    id: string,
    name: string,
}

export enum ErrorType {
    ServerError = 'serverError',
    ServerWarning = 'serverWarning',
    ValidationError = 'validationError',
    ValidationWarnings = 'validationWarning',
}

type TypeSpec = {
    code: ErrorType,
    name: string,
}

export const ErrorTypeObj: { [key in ErrorType]: Omit<TypeSpec, 'code'> } = {
    [ErrorType.ServerError]: { name: 'Ошибка сервера' },
    [ErrorType.ServerWarning]: { name: 'Предупреждение сервера' },
    [ErrorType.ValidationError]: { name: 'Ошибка валидации' },
    [ErrorType.ValidationWarnings]: { name: 'Предупреждение валидации' },
}

export const ErrorTypeList: TypeSpec[] = Object.values(ErrorType).map(code => ({
    code,
    ...ErrorTypeObj[code],
}))

export type VersionServerError = {
    type: ErrorType,
    code: number,
    rule: string,
    message: string,
    solution: string,
    links: [
        {
            entityId: string,
            id: string[],
        },
    ],
}